export const roleMapping = [
    {
        id: 23,
        roleName: "Digital Stores",
        roleDescription:
        "User has access to the Promo Planning Tool",
        createdAt: "2026-03-02T22:05:22.080Z",
        modifiedAt: "2026-03-02T22:05:22.080Z",
    },
    {
        id: 22,
        roleName: 'RL Import Template',
        roleDescription: 'User has access to the RL Import and Updates Templates to generate',
        createdAt: '2025-03-17T22:05:22.080Z',
        modifiedAt: '2025-03-17T22:05:22.080Z',
    },
    {
        id: 21,
        roleName: 'Rightsline Product Gate Content Sales (ESPN+ Read Only)',
        roleDescription:
            'Visibility to both the Content Sales tab and the ESPN+ tab, no ability to move things from Content Sales tab to ESPN+ tab, no ability to move things from ESPN+ tab to Content Sales tab, ability to click "Add" on Content Sales tab, no ability to click "Add" on ESPN+ tab',
        createdAt: '2024-10-10T05:42:04.270Z',
        modifiedAt: '2024-10-10T05:42:04.270Z',
    },
    {
        id: 20,
        roleName: 'RL Product Gate Admin',
        roleDescription:
            'Visibility to both the Content Sales tab and the ESPN+ tab, ability to move things from Content Sales tab to ESPN+ tab, ability to move things from ESPN+ tab to Content Sales tab, ability to click "Add" on Content Sales tab, ability to click "Add" on ESPN+ tab',
        createdAt: '2024-09-30T21:29:33.257Z',
        modifiedAt: '2024-09-30T21:29:33.257Z',
    },
    {
        id: 19,
        roleName: 'Rightsline Product Gate ESPN+',
        roleDescription:
            'Visibility to both the Content Sales tab and the ESPN+ tab, ability to move things from Content Sales tab to ESPN+ tab, ability to move things from ESPN+ tab to Content Sales tab, ability to click "Add" on Content Sales tab, no ability to click "Add" on ESPN+ tab',
        createdAt: '2024-09-06T21:00:24.567Z',
        modifiedAt: '2024-09-06T21:00:24.567Z',
    },
    {
        id: 18,
        roleName: 'Deal Versioning-Read Only',
        roleDescription:
            'Ready Only access to view any of the Deal Versioning reports getting downloaded out of Data Stage',
        createdAt: '2023-07-05T21:40:01.793Z',
        modifiedAt: '2023-07-05T21:40:01.793Z',
    },
    {
        id: 17,
        roleName: 'TV Legal Admin',
        roleDescription:
            'Administrator access to TV related sections of Clearance Memos and Reports',
        createdAt: '2023-05-19T07:13:34.150Z',
        modifiedAt: '2023-05-19T07:13:34.150Z',
    },
    {
        id: 16,
        roleName: 'Tap Admin',
        roleDescription: 'Administrator access to TAP',
        createdAt: '2022-10-21T23:35:11.990Z',
        modifiedAt: '2022-10-21T23:35:11.990Z',
    },
    {
        id: 15,
        roleName: 'PMX User',
        roleDescription: 'Access to PMX UI',
        createdAt: '2022-06-22T01:41:28.020Z',
        modifiedAt: '2022-06-22T01:41:28.020Z',
    },
    {
        id: 14,
        roleName: 'Rightsets Associate',
        roleDescription: 'Access to Associate Rightsets funtionality',
        createdAt: '2022-04-27T03:32:18.740Z',
        modifiedAt: '2022-04-27T03:32:18.740Z',
    },
    {
        id: 13,
        roleName: 'Rightsets',
        roleDescription: 'Access to Rightsets',
        createdAt: '2022-04-07T22:14:27.987Z',
        modifiedAt: '2022-04-07T22:14:27.987Z',
    },
    {
        id: 12,
        roleName: 'Tap User',
        roleDescription: 'Access to TAP',
        createdAt: '2022-02-26T00:49:36.517Z',
        modifiedAt: '2022-02-26T00:49:36.517Z',
    },
    {
        id: 11,
        roleName: 'Product Comments Admin',
        roleDescription: 'Administrator access to Clearance Memos Product Comments',
        createdAt: '2021-11-24T03:38:30.330Z',
        modifiedAt: '2021-11-24T03:38:30.330Z',
    },
    {
        id: 10,
        roleName: 'Deal Versioning',
        roleDescription: 'Access to Deal Versioning',
        createdAt: '2021-06-01T23:14:38.703Z',
        modifiedAt: '2021-06-01T23:14:38.703Z',
    },
    {
        id: 9,
        roleName: 'Legal User',
        roleDescription: 'Inquiry access to Clearance Memos',
        createdAt: '2020-11-25T05:14:16.857Z',
        modifiedAt: '2020-11-25T05:14:16.857Z',
    },
    {
        id: 8,
        roleName: 'Legal Admin',
        roleDescription: 'Administrator access to Clearance Memos and Reports',
        createdAt: '2020-11-25T05:14:16.840Z',
        modifiedAt: '2020-11-25T05:14:16.840Z',
    },
    {
        id: 7,
        roleName: 'Job Tracker',
        roleDescription:
            'Access to RADAR Product Update Report Jobs Tracker + Date Math Import Jobs Tracker + Air Date Import Jobs Tracker + all other jobs trackers',
        createdAt: '2020-04-03T22:21:10.470Z',
        modifiedAt: '2020-04-03T22:21:10.470Z',
    },
    {
        id: 6,
        roleName: 'Apollo Error Report',
        roleDescription: 'Access to Apollo Sync Error Report',
        createdAt: '2020-04-03T22:21:10.457Z',
        modifiedAt: '2020-04-03T22:21:10.457Z',
    },
    {
        id: 5,
        roleName: 'WON Error Report',
        roleDescription: 'Access to WON Error Report',
        createdAt: '2020-04-03T22:21:10.457Z',
        modifiedAt: '2020-04-03T22:21:10.457Z',
    },
    {
        id: 4,
        roleName: 'Air Date Ingestion Tool',
        roleDescription: 'Access to Air Date Import + Air Date Import Jobs Tracker',
        createdAt: '2020-04-03T22:21:10.457Z',
        modifiedAt: '2020-04-03T22:21:10.457Z',
    },
    {
        id: 3,
        roleName: 'Bulk Date Math Tool',
        roleDescription: 'Access to Date Math Import + Date Math Import Jobs Tracker',
        createdAt: '2020-04-03T22:21:10.457Z',
        modifiedAt: '2020-04-03T22:21:10.457Z',
    },
    {
        id: 2,
        roleName: 'RL Product Gate Content Sales',
        roleDescription:
            'Visibility to only the Content Sales tab of the RL Product Gate, no visibility to ESPN+ tab, no ability to move things from Content Sales tab to ESPN+ tab, ability to click "Add" on Content Sales tab',
        createdAt: '2020-04-03T22:21:10.457Z',
        modifiedAt: '2020-04-03T22:21:10.457Z',
    },
    {
        id: 1,
        roleName: 'Administrator',
        roleDescription:
            'Access to all admin features including the abilty to add or remove users and assign them roles',
        createdAt: '2020-04-03T22:21:10.457Z',
        modifiedAt: '2020-04-03T22:21:10.457Z',
    },
];
